import '../css/landing.css';
import main from '../assets/landingbg.jpeg';
import { useNavigate } from 'react-router-dom';

export default function Landing() {
    const navigate = useNavigate();
    return(
        <div className="landing">
                <span className="left">
                    <div className="caption1">
                        <hr />
                        <h4>WE ARE UDAAN SEWA TRUST</h4>
                    </div>
                    <div className="titles">
                        <div className="caption2">
                            <p>We work towards<span> Women Empowerment</span> and overall development of our <span>Society</span> </p>
                        </div>
                        <div className="caption3">
                            <p>हम शिक्षा, महिला सशक्तिकरण, ग्राम विकास, पर्यावरण संरक्षण एवं जनकल्याण के क्षेत्रों में कार्य करते हुए विशेष रूप से बच्चों में कुपोषण को कम करने पर ध्यान देते हैं, ताकि वंचित एवं असहाय वर्गों को आत्मनिर्भर बनाया जा सके।</p>
                        </div>
                        <div className="btns">
                            <button onClick={() => window.open("/about", "_blank", "noopener noreferrer")} type="button" className="btn btn-outline-info">Know More</button>
                            <button type="button" className="btn btn-success" onClick={()=>navigate("/donate")}>DONATE</button>
                        </div>
                    </div>

                </span>
                <span className="right">
                    <img src={main} alt="Smiling Faces" />
                </span>
            </div>
    );
}